export const isPharmacyVerified = (status: string) => status === 'PharmacyVerified';

export const prescriptionStatusLabel = (status: string) =>
  isPharmacyVerified(status) ? 'eRx Received by Pharmacy' : 'eRx Processing';
